<template>
  <div class="home-page">
    <div class="home-entry">
      <div class="contain">
        <!-- banner轮播图 -->
        <HomeBanner />
        <!-- 媒体概况 -->
        <HomeServe id="serve" />
        <!-- 优势 -->
        <HomeAdvantage />
        <!-- 常见问题 -->
        <HomeQuestion  id="question" />
        <!-- 窗口右侧固定栏 -->
        <AppRight />
      </div>
    </div>
  </div>
</template>

<script>
import HomeBanner from './components/home-banner.vue'
import HomeServe from './components/home-serve.vue'
import HomeAdvantage from './components/home-advantage.vue'
import HomeQuestion from './components/home-question.vue'
import AppRight from '../../components/app-right.vue'
export default {
  name: 'HomePage',
  components: {
    HomeBanner,
    HomeServe,
    HomeAdvantage,
    HomeQuestion,
    AppRight
  }
}
</script>

<style lang="less" scoped>
.home-page {
  background-color: #f8f8f8;
  .home-entry {
    .container {
      display: flex;
      justify-content: flex-start;
    }
  }
}
</style>
